import React from "react";

import MuiSkeleton from "@material-ui/lab/Skeleton";
import { Grid } from "@material-ui/core";

const Title = (props) => (
  <MuiSkeleton height={50} width={props.small ? "80%" : "100%"} />
);

const Image = () => (
  <MuiSkeleton style={{ marginTop: 0 }} height={300} width="100%" />
);

const SubTitle = (props) => (
  <MuiSkeleton height={30} width={!props.fullWidth ? "80%" : "100%"} />
);

const Counter = () => <MuiSkeleton height={30} width={80} />;

const Chart = () => <MuiSkeleton height={500} />;

const Skeleton = () => {
  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={6}>
        <Title />
        <SubTitle />
      </Grid>
      <Grid item xs={12} md={6}>
        <Title />
        <SubTitle />
      </Grid>
      <Grid item xs={12} md={12}>
        <Title />
        <SubTitle />
      </Grid>
      <Grid item xs={12} md={6}>
        <Title />
        <Image />
      </Grid>
      <Grid item xs={12} md={6}>
        <Title />
        <Image />
      </Grid>
      <Grid item xs={12} md={6}>
        <Title />
        <Counter />
      </Grid>
      <Grid item xs={12} md={6}>
        <Title />
        <Counter />
      </Grid>
      <Grid item md={12} xl={6}>
        <Chart />
      </Grid>
      <Grid item md={12} xl={6}>
        <Chart />
      </Grid>
    </Grid>
  );
};

export default React.memo(Skeleton);
